<input
  (change)="onFileSelected($event)"
  type="file"
  id="file"
  class="dn"
  accept=".pdf"
  #fileupload />
@if (!isLoaded && progressData) {
  <dx-progress-bar
    class="pa"
    style="z-index: 10; top: -9px"
    width="100%"
    [min]="0"
    [max]="100"
    [showStatus]="false"
    [value]="(progressData.loaded / progressData.total) * 100">
  </dx-progress-bar>
}
<div class="interface">
  @if (!hideToolBar) {
    <div class="interface-header toolbar">
      <div>
        <div class="grid-row grid-row-3 grid-gap-20 nw grid-nowrap">
          <div>
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
              (click)="incrementZoom(0.1)">
              <i class="icon-zoom-in" title="Zoom in"></i>
            </a>
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
              (click)="incrementZoom(-0.1)">
              <i class="icon-zoom-out" title="Zoom Out"></i>
            </a>
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
              title="Rotate Left"
              (click)="rotate(-90)">
              <i class="icon-ccw"></i>
            </a>
            <a
              href="javascript:void(0)"
              class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
              title="Rotate Right"
              (click)="rotate(90)">
              <i class="icon-cw"></i>
            </a>
            @if (!simpleView) {
              <a
                href="javascript:void(0)"
                class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
                (click)="showAll = !showAll">
                <i
                  [class.icon-docs]="showAll"
                  [class.icon-doc]="!showAll"
                  title="Toggle Show All"></i>
              </a>
            }
          </div>
          @if (!simpleView) {
            <div class="flex-row grid-gap-20">
              @if (!showAll && pdf) {
                <a
                  href="javascript:void(0)"
                  class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
                  title="Prev Page"
                  (click)="incrementPage(-1)">
                  <i class="icon-left-big"></i>
                </a>
                <div class="plr15 max acenter text-medium">{{ page }} of {{ pdf.numPages }}</div>
                <a
                  href="javascript:void(0)"
                  class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
                  title="Next Page"
                  (click)="incrementPage(1)">
                  <i class="icon-right-big"></i>
                </a>
              }
            </div>
            <div class="flex-row w100 grid-gap-20">
              <div style="min-width: 150px">
                <dx-text-box
                  valueChangeEvent="change keyup"
                  (onValueChanged)="searchQueryChanged($event.value)"
                  [showClearButton]="true"
                  placeholder="{{ 'actions.search' | translate }}">
                </dx-text-box>
              </div>
              <div class="max aright">
                <a
                  href="javascript:void(0)"
                  class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
                  id="printBtn"
                  [class.icon-bg-warning]="isTabletDevice || isTouchDevice || isMobileDevice"
                  [class.disabled]="!isLoaded"
                  (click)="print()">
                  <i class="icon-print" title="Print"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="simple-btn simple-btn-md simple-btn-icon icon-bg btn-round"
                  (click)="downloadPDF()">
                  <i class="icon-download" title="Download"></i>
                </a>
                <dx-tooltip
                  target="#printBtn"
                  position="left"
                  [(visible)]="tooltipMobilePrintWarningVisible">
                  <div>
                    <b>Impossible to print PDF from mobile browser</b><br />
                    Please download the file and print from your PDF viewer app
                  </div>
                </dx-tooltip>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <div class="interface-content loader-overlay" [class.loading]="isPrintPreparationProgress">
    <pdf-viewer
      id="pdfViewerElement"
      [src]="pdfSrc"
      [rotation]="rotation"
      [original-size]="originalSize"
      [show-all]="showAll"
      [fit-to-page]="fitToPage"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"
      [stick-to-page]="stickToPage"
      [render-text]="renderText"
      [external-link-target]="'blank'"
      [autoresize]="autoresize"
      [show-borders]="true"
      [page]="page"
      (error)="onError($event)"
      (on-progress)="onProgress($event)"
      (after-load-complete)="afterLoadComplete($event)"></pdf-viewer>
  </div>
</div>
